/* eslint-disable import/prefer-default-export */
import Request from 'commons/libs/requests';

export async function getDoctor(doctorID: string) {
  return (await Request.get(`/api-patients/doctors/${doctorID}/`)).data;
}
